import { render, staticRenderFns } from "./global-warn.vue?vue&type=template&id=3abdd58a&scoped=true&"
import script from "./global-warn.vue?vue&type=script&lang=js&"
export * from "./global-warn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abdd58a",
  null
  
)

export default component.exports